export const canvasToBlob = (canvas: HTMLCanvasElement, type?: string, quality?: number): Promise<Blob> =>
    new Promise((resolve, reject) => {
        canvas.toBlob(
            blob => {
                if (blob) {
                    resolve(blob)
                } else {
                    reject(new Error("Canvas toBlob() returned null"))
                }
            },
            type,
            quality
        )
    })
